import React from 'react';
import { renderToString } from 'react-dom/server';

export const tooltipRowTemplate = ({ color, name, y, backgroundColor }) =>
  renderToString(
    <tr>
      <td className="text-left p-l-0">
        <span
          className="v-a-m legend-bubble-marker"
          style={{ backgroundColor: backgroundColor || color, borderColor: color, marginRight: 8 }}
        />
        <span className="v-a-m d-inline-block text-truncate text-14" style={{ maxWidth: 150 }}>
          {name}
        </span>
      </td>
      <td className="text-right text-14">{y}</td>
    </tr>
  );
